import { Component, OnInit } from '@angular/core';
import { LoginService } from '../login/login.service';
import { Router } from '@angular/router';
@Component({
  selector: 'app-staff-sidebar',
  templateUrl: './staff-sidebar.component.html',
  styleUrls: ['./staff-sidebar.component.css']
})
export class StaffSidebarComponent implements OnInit {
  token:any
  storedData:any
  click:any='works'
  constructor(public router:Router,private loginService:LoginService) { }

  ngOnInit(): void {
    this.token = localStorage.getItem('token');
    this.storedData = JSON.parse(localStorage.getItem("user") || '{}');
  }
  logOut(){

    let storedData = JSON.parse(localStorage.getItem("user") || '{}');


let data = {
  "userId": storedData._id || null
};
    this.loginService.logOut(data,this.token).subscribe((response: any) => {
      if (response.status == 1) {

        this.router.navigate(["/login"])



        }
      })



this.router.navigate(["/login"])

  }
  profile(){
    this.router.navigate(["/profile"])

  }
  route(){
    if(this.click=='works'
    ){
      this.router.navigate(["/works"])

    }
    else   if(this.click=='products'
    ){
      this.router.navigate(["/product-list"])

    }
    else   if(this.click=='dashboard'
    ){
      this.router.navigate(["/main-dashboard"])

    }
     else  if(this.click=='staff'
    ){
      this.router.navigate(["/staff-list"])

    }

    else  if(this.click=='clients'
    ){
      this.router.navigate(["/client-list"])

    }
    else  if(this.click=='report'
    ){
      this.router.navigate(["/report"])

    }
    else  if(this.click=='company'
    ){
      this.router.navigate(["/work-page"])

    }
  }



}
